import { BaseApi } from './base.api.js';

export class CommunicationProviderApi extends BaseApi {
    constructor(client, basePath = '/communication-provider') {
        super(client, basePath);
    }

    /** Send a probe message through the saved provider credentials. */
    async test(id, payload) {
        const response = await this.client.post(`${this.basePath}/${id}/test`, payload);
        return response.data;
    }
}
